import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { ROUTE_BENCHMARK_INSIGHT_INDEX } from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

export default class HotelBenchmarkInsightUpsellRoute extends Route {
  @service declare access: Services['access'];
  @service('benchmark-insight/trial')
  declare benchmarkInsightTrial: Services['benchmark-insight/trial'];
  @service declare router: Services['router'];
  @service declare usageAnalytics: Services['usage-analytics'];

  afterModel(): void {
    // The event is called 'Upsell Starting' because we want to capture the intent of the user to start a trial for Benchmark Insight.
    // When the user actually starts a Benchmark Insight trial, that event would be called 'Upsell Started'.
    // Accompanying legacy usage tracking is done with route tracking of the `hotel.benchmark-insight.upsell` route in `route-mapping.csv`.
    this.usageAnalytics.track('Upsell Starting', {
      eventTrigger: 'upsell-tab',
      product: 'benchmark-insight upsell',
    });
  }

  beforeModel(): void {
    if (this.access.hasBenchmarkInsight) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.router.legacyTransitionTo(ROUTE_BENCHMARK_INSIGHT_INDEX);
    }
  }

  model(): void {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.benchmarkInsightTrial.upsellApiResponseTask.perform();
  }
}
